"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));
var _toPath = _interopRequireDefault(require("lodash/fp/toPath"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Locale = _interopRequireDefault(require("@active/react-utils/i18n/Locale"));
var _Form = require("../Form");
var _utils = require("../Form/utils");
var _FormGroup = require("../FormGroup");
var _excluded = ["className", "errorId", "error", "touched", "renderError", "labelText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INTERNAL_ERROR_KEYS = ['react-ui.validation.required', 'react-ui.validation.invalid'];
var _getTouchedPaths = function getTouchedPaths(node) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if ((0, _typeof2["default"])(node) === 'object') {
    var touchedPaths = (0, _toPairs["default"])(node).reduce(function (paths, _ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];
      var currentPath = [path, key].filter(Boolean).join('.');
      var currentTouchedPaths = _getTouchedPaths(v, currentPath);
      return [].concat((0, _toConsumableArray2["default"])(paths), (0, _toConsumableArray2["default"])(currentTouchedPaths));
    }, []);
    if (touchedPaths.length) {
      path && touchedPaths.push(path);
    }
    return touchedPaths;
  }
  return node ? [path] : [];
};
var isFieldTouched = function isFieldTouched(fieldName) {
  return function (touched) {
    var pathFieldName = (0, _toPath["default"])(fieldName).join('.');
    return (0, _compose["default"])((0, _includes["default"])(pathFieldName), _getTouchedPaths)(touched);
  };
};
var ErrorContent = function ErrorContent(_ref3) {
  var id = _ref3.id,
    fieldName = _ref3.fieldName;
  if (fieldName && (0, _includes["default"])(id)(INTERNAL_ERROR_KEYS)) {
    return /*#__PURE__*/_react["default"].createElement(_Locale["default"], {
      id: "".concat(id, ".specifyField"),
      params: {
        fieldName: fieldName
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_Locale["default"], {
    id: id
  });
};
var FormFieldError = function FormFieldError(props) {
  var className = props.className,
    errorId = props.errorId,
    error = props.error,
    touched = props.touched,
    renderError = props.renderError,
    labelText = props.labelText,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (!(0, _utils.hasFieldError)(error, touched)) return null;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('form-group-error', className),
    id: errorId,
    role: "alert",
    "aria-live": "assertive",
    "aria-relevant": "additions text"
  }, (0, _omit["default"])(['labelId', 'inputId', 'withoutLayout', 'name', 'setLabelText'])(rest)), /*#__PURE__*/_react["default"].createElement("i", {
    className: "ic-cross-r",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("span", null, renderError ? renderError(_objectSpread({}, (0, _omit["default"])(['renderError'])(props))) : /*#__PURE__*/_react["default"].createElement(ErrorContent, {
    id: error,
    fieldName: labelText
  })));
};
var FormFieldErrorContainer = (0, _compose["default"])(_FormGroup.connectFormGroup, (0, _curryRight["default"])(_Form.connectForm)(function (_ref4, _ref5) {
  var _ref4$form = _ref4.form,
    errors = _ref4$form.errors,
    touched = _ref4$form.touched;
  var name = _ref5.name;
  return {
    error: (0, _prop["default"])(name)(errors),
    touched: isFieldTouched(name)(touched)
  };
}), _react.memo)(FormFieldError);
var _default = exports["default"] = FormFieldErrorContainer;